/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionnaireRequestListItemModel } from '../../models/questionnaire-request-list-item-model';

export interface ApiConsumerQuestionnaireQueueGet$Params {
}

export function apiConsumerQuestionnaireQueueGet(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireQueueGet$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<Array<QuestionnaireRequestListItemModel>>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireQueueGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<Array<QuestionnaireRequestListItemModel>>;
    })
  );
}

apiConsumerQuestionnaireQueueGet.PATH = '/api/consumer/questionnaire/queue';
